import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getAPIURL } from "helpers";
import { getBaseQueryWithRejection } from "redux/helper.redux";

const baseQueryWithRejection = getBaseQueryWithRejection(
  fetchBaseQuery({
    baseUrl: getAPIURL("/api/pvsa/letter-pdf-router"),
    prepareHeaders: (headers, { getState }) => {
      const token = getState().auth.accessToken;
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    },
  })
);

export const downloadDocumentApi = createApi({
  reducerPath: "downloadDocumentApi",
  baseQuery: baseQueryWithRejection,
  tagTypes: [],
  endpoints: (builder) => ({
    downloadDForm: builder.mutation({
      query: ({ templateId, movementId }) => ({
        url: `/generate-pdf/?reportId=${templateId}&movement_id=${movementId}`,
        method: "GET",
      }),
    }),
  }),
});

export const { useDownloadDFormMutation } = downloadDocumentApi;
